import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Form, FormInstance, Input, InputNumber, Select } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { MdOutlineCheckBoxOutlineBlank } from 'react-icons/md';
import { RiCheckboxBlankCircleLine } from 'react-icons/ri';
import { surveyStore } from 'stores/root_store';
import { QuestionType } from '../models';

type quizProps = {
  restField: {
    fieldKey?: number | undefined;
  };
  form: FormInstance;
  index: number;
  remove: (index: number | number[]) => void;
  name: string | undefined;
  questionIdx: number;
  sessionId?: string;
  addItem: (defaultValue?: any, insertIndex?: number | undefined) => void;
};

const Quiz = (props: quizProps) => {
  const { restField, index, remove, questionIdx, form, sessionId, addItem } = props;

  const type = useWatch(['questions', questionIdx, 'type'], form);
  const hasPoint = useWatch(['questions', questionIdx, 'hasPoint'], form);

  const sessionIdx = surveyStore.sessions?.findIndex((i) => i.id === sessionId) as number;
  const sessions = surveyStore.sessions?.filter((item, index) => index > sessionIdx);


  return (
    <div className="flex gap-2">
      <Form.Item wrapperCol={{ span: 24 }} className="!mb-2" labelCol={{ span: 4 }}>
        <div className="md:w-[105px] flex justify-end items-center">
          {type === QuestionType.QUIZ ? (
            <RiCheckboxBlankCircleLine className="text-[23px] text-gray-400" />
          ) : (
            type === QuestionType.MULTI_CHOICE && (
              <MdOutlineCheckBoxOutlineBlank className="text-[25px] !text-gray-400" />
            )
          )}
        </div>
      </Form.Item>
      <div className="md:flex md:gap-3 w-full">
        <Form.Item
          {...restField}
          name={[index, 'title']}
          className="!mb-2 w-full md:w-[45%]"
          wrapperCol={{ span: 24 }}
          rules={[{ required: true, message: 'chưa nhập câu trả lời' }]}
        >
          <Input size="small" placeholder={`Nhập tùy chọn ${index + 1}`} />
        </Form.Item>
        {type === QuestionType.QUIZ && (
          <Form.Item {...restField} wrapperCol={{ span: 24 }} className="!mb-2" name={[index, 'part']}>
            <Select
              size="small"
              className="!w-[200px]"
              fieldNames={{ label: 'name', value: 'id' }}
              options={sessions}
              placeholder="Chọn phần"
              notFoundContent={<div className='text-center h-6 text-gray-500'>Vui lòng thêm phần</div>}
            />
          </Form.Item>
        )}
        <Form.Item {...restField} wrapperCol={{ span: 24 }} className="!mb-2" name={[index, 'score']}>
          <InputNumber size="small" className="!w-full" disabled={!hasPoint} placeholder="Nhập điểm" />
        </Form.Item>

        <Form.Item {...restField} wrapperCol={{ span: 24 }} hidden className="!mb-2" name={[index, 'id']}>
          <Input />
        </Form.Item>

        {index === 0 ?
          <Form.Item className="!mb-2">
            <PlusCircleOutlined onClick={() => addItem()} />
          </Form.Item>
          :
          <Form.Item className="!mb-2">
            <MinusCircleOutlined onClick={() => remove(index)} />
          </Form.Item>
        }
      </div>
    </div>
  );
};

export default Quiz;
